import { isStudent, isTeacher, isManager, isRegistered, isNotRegistered, isRegistrationStage, itIsMyCompetition } from '../utils';


export const buildStarsChallengeProps = (block, state, authState) => {

    const isUserIdentified = authState?.isAuth === true;
    const { props } = block;

    const buildProps = () => {

        let text = props.text?.default ?? null;
        let button = props.button?.default ?? null;
        let title = props.title?.default ?? null;
        let image = props.image?.default ? { ...props.image?.default, src: props.image?.default?.src } : null;
        let link = props.link?.default ? { ...props.link.default } : null;
        let textImg = props.textImg?.default ? { ...props.textImg.default } : null;
        let registrationMessage = null;

        if (!isUserIdentified) {
            text = props.text?.not_identified ?? props.text?.default ?? null;
            button = props.button?.register ?? props.button?.default ?? null;
        }
        else if (isStudent(state)) {
            text = props.text?.student ?? props.text?.default ?? null;
            if (isRegistrationStage(state))
                button = null;
            else
                button = props.button?.play_now ?? props.button?.default ?? null;
            }
        else if ((isTeacher(state) || isManager(state)) && isRegistered(state)) {
            text = props.text?.teacher_registered ?? props.text?.default ?? null;
            button = props.button?.update_registration
            registrationMessage = props.registrationMessage?.teacher_registered ?? null;
        }
        else if ((isTeacher(state) || isManager(state)) && !isNotRegistered(state)) {
            text = props.text?.teacher_not_registered ?? props.text?.default ?? null;
            button = props.button?.register ?? props.button?.default ?? null;
        }

        if (!itIsMyCompetition(state, authState))
            button = null;
        return {
            title,
            text,
            image,
            button,
            link,
            textImg,
            registrationMessage
        };
    };

    const resolvedProps = buildProps();

    return {
        id: block.id,
        type: block.type,
        props: resolvedProps,
    };
}

